import { AccountOrders } from 'pages/account/account-orders/account-orders';
import AuthRequired from 'pages/authentication/components/auth-required';

export default function AccountOrdersPage() {
  return (
    <AuthRequired>
      <AccountOrders />
    </AuthRequired>
  );
}
